import projectsRoutingKeys from "Areas/Projects/routingKeys";
import { actionCreators as editorActionCreators } from "Areas/WorkSpaces/workSpaceEditorPanel";
import { Permissions, security } from "Common/permissions";
import { REDUX_ROUTER_NAMESPACE, routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getInProgress, getWorkSpaces } from "./redux/selectors";
import WorkSpacesSidebarMenu from "./workSpacesSidebarMenu";
const getProjectDetailsHref = (projectId) => routesAndPagesMap.getPath(projectsRoutingKeys.PROJECT_DETAILS, projectId);
const canGetWorkSpaces = security.isAllowed([Permissions.WorkSpacesView]);
const canEditWorkSpaces = security.isAllowed([Permissions.WorkSpacesEdit]);
const canEditProjects = security.isAllowed([Permissions.ProjectsEdit]);
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const canEditSummaryReports = security.isAllowed([Permissions.SummaryReportsEdit]);
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        locationHash: (_b = (_a = state[REDUX_ROUTER_NAMESPACE]) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hash,
        inProgress: getInProgress(state),
        workSpaces: getWorkSpaces(state),
        getProjectDetailsHref,
        canGetWorkSpaces,
        canEditWorkSpaces,
        canEditProjects,
        canEditDocuments,
        canEditSummaryReports
    });
};
const mapDispatchToProps = (dispatch) => ({
    onGetWorkSpaces: () => dispatch(actionCreators.getWorkSpaces()),
    onOpenWorkSpaceCreatorPanel: () => dispatch(editorActionCreators.setNewWorkSpace())
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkSpacesSidebarMenu);
